import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';

import { DocorgaCoreModule, Environment } from '@docorga-v1/docorga-angular';

registerLocaleData(localeFr, 'fr');

import { AppComponent } from './app.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { PrlCoreModule } from './core/prl-core.module';
import { ServicesModule } from './shared/services/services.module';
import { environment } from '@environments/environment';

@NgModule({
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR',
    },
    {
      provide: Environment,
      useValue: environment,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    DocorgaCoreModule,
    PrlCoreModule,
    ServicesModule.forRoot(),
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'home',
        },
        {
          path: 'home',
          loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
        },
        {
          path: 'praticien',
          loadChildren: () => import('./praticien/praticien.module').then((m) => m.PraticienModule),
        },
        {
          path: 'appointment',
          loadChildren: () => import('./appointment/appointment.module').then((m) => m.AppointmentModule),
        },
        {
          path: 'mySpace',
          loadChildren: () => import('./mySpace/mySpace.module').then((m) => m.MySpaceModule),
        },
        {
          path: 'conversation',
          loadChildren: () => import('./conversation/conversation.module').then((m) => m.ConversationModule),
        },
        {
          path: 'checkout',
          loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutModule),
        },
        {
          path: 'anonymous',
          loadChildren: () => import('./anonymous/anonymous.module').then((m) => m.AnonymousModule),
        },
        {
          path: 'cgu',
          loadChildren: () => import('./cgu/cgu.module').then((m) => m.CguModule),
        },
        {
          path: '**',
          data: {
            hideNavigation: true,
          },
          component: NotFoundComponent,
        },
      ],
      {}
    ),
    NgxLinkifyjsModule.forRoot(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
